<template>
  <h1>{{ value }}</h1>
</template>

<script>
export default {
  name: "ControlHeadline",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>
